export const LEGACY_CAL_REPORT_FETCHING = 'LEGACY_CAL_REPORT_FETCHING';
export const LEGACY_CAL_REPORT_FETCHED = 'LEGACY_CAL_REPORT_FETCHED';
export const LEGACY_CAL_REPORT_FAILED = 'LEGACY_CAL_REPORT_FAILED';
export const LEGACY_CAL_REPORT_RESET = 'LEGACY_CAL_REPORT_RESET';
export const GENERIC_ERROR_MESSAGE = 'Failed to fetch legacy calibration report. Please try again later.';
